<script lang="ts">
  import { ViewerIcon } from '@shared/libs/lotties';
  import { viewerIconDOTriggers } from '@shared/libs/lotties/models';
  import { theme, ThemeModes } from '@shared/ui/theme';
  import { cn } from '@shared/utils';

  let uid = Symbol();
</script>

<div
  class="relative mx-auto w-max border border-transparent pl-3 pr-5"
  on:mouseenter="{() => viewerIconDOTriggers.oneTimeTrigger(uid)}"
  on:mouseleave="{() => viewerIconDOTriggers.reverseTrigger(uid)}"
  role="button"
  tabindex="0"
  aria-label="View in Full Resolution"
>
  <div
    class="{cn(
      'dark:after:bg-store-dark animation custom-bg absolute inset-0 rounded-lg after:absolute after:inset-[1px] after:z-[1] after:block after:rounded-lg after:bg-white',
      {
        'custom-bg-dark custom-gradient-dark': $theme === ThemeModes.Dark,
        'custom-gradient': $theme !== ThemeModes.Dark,
      },
    )}"
  ></div>

  <div class="relative z-10 flex items-center justify-center gap-2 py-1.5">
    <ViewerIcon width="{26}" {uid} />

    <span class="text-sm font-medium">View in Full Resolution</span>
  </div>
</div>

<style lang="scss">
  @property --r {
    syntax: '<angle>';
    inherits: false;
    initial-value: 0deg;
  }

  .custom-bg {
    background: #ccc;
  }

  .custom-bg-dark {
    background: #171717;
  }

  .custom-gradient {
    background: conic-gradient(from var(--r), #ccc 0%, #171717 10%, #ccc 20%);
  }

  .custom-gradient-dark {
    background: conic-gradient(from var(--r), #525252 0%, #eee 10%, #525252 20%);
  }

  .animation {
    animation: rotating 3s linear infinite;
  }

  @keyframes rotating {
    0% {
      --r: 0deg;
    }
    100% {
      --r: 360deg;
    }
  }
</style>
